import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon,
  FormGroup,
  FormField,
  Button,
  Input
} from 'semantic-ui-react'

const CardBindIdUX = (props: any) => {
    return(
      <div>
        <div
          className="ui accordion fluid raised segment"
          id="CardBindIdUX-div-1"
          style={{boxShadow: "none"}}>
          
          <div
            id="CardBindIdUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <label
              id="CardBindIdUX-label-3"
              style={{fontSize: "1.2rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Please check your information and enter your IsHealth ID (IH ID)." : "กรุณาตรวจสอบข้อมูลและกรอก IsHealth ID (IH ID)"}
            </label>
            <div
              id="CardBindIdUX-div-4"
              style={{cursor: "pointer"}}>
              {}
              <Icon
                className="red large"
                id="CardBindIdUX-Icon-5"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
          <div
            className="ui divider"
            id="CardBindIdUX-div-6">
            
          </div>
          <div
            className="ui form"
            id="CardBindIdUX-div-7">
            
            <div
              id="CardBindIdUX-div-58">
              {props.ErrorMessage}
            </div>
            <FormGroup
              id="CardBindIdUX-FormGroup-8"
              inline={true}>
              <FormField
                id="CardBindIdUX-FormField-10"
                inline={true}
                width={3}>
                <label
                  id="CardBindIdUX-label-15">
                  {props.languageUX === "en" ? "HN:" : "HN:"}
                </label>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-11"
                inline={true}
                width={7}>
                <label
                  id="CardBindIdUX-label-38">
                  {props.hn}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBindIdUX-FormGroup-9"
              inline={true}>
              <FormField
                id="CardBindIdUX-FormField-20"
                inline={true}
                width={3}>
                <label
                  id="CardBindIdUX-label-25">
                  {props.languageUX === "en" ? "First name & Last Name" : "ชื่อ-นามสกุล:"}
                </label>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-21"
                inline={true}
                width={7}>
                <label
                  id="CardBindIdUX-label-39">
                  {props.fullName}
                </label>
              </FormField>
            </FormGroup>
            <div
              className="inline fields"
              id="CardBindIdUX-div-53"
              style={{...(!props.bindHn && {display: "none"})}}>
              
              <FormField
                id="CardBindIdUX-FormField-54"
                inline={true}
                width={3}>
                <label
                  id="CardBindIdUX-label-56">
                  {props.languageUX === "en" ? "E-mail:" : "อีเมล:"}
                </label>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-55"
                inline={true}
                width={7}>
                <label
                  id="CardBindIdUX-label-57">
                  {props.email}
                </label>
              </FormField>
            </div>
            <FormGroup
              id="CardBindIdUX-FormGroup-45"
              inline={true}>
              <FormField
                id="CardBindIdUX-FormField-46"
                inline={true}
                width={3}>
                <label
                  id="CardBindIdUX-label-48">
                  {props.languageUX === "en" ? "IH ID:" : "รหัสประจำตัว IH:"}
                </label>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-47"
                inline={true}
                width={7}>
                <Input
                  id="CardBindIdUX-Input-50"
                  onChange={props.onChange}
                  value={props.ihid}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBindIdUX-FormGroup-34">
              <FormField
                id="CardBindIdUX-FormField-35"
                inline={true}
                width={11}>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-36"
                inline={true}
                width={3}>
                <Button
                  color={"blue"}
                  fluid={true}
                  id="CardBindIdUX-Button-37"
                  onClick={props.onConfirm}>
                  {props.languageUX === "en" ? "Confirm" : "ยืนยัน"}
                </Button>
              </FormField>
              <FormField
                id="CardBindIdUX-FormField-51"
                inline={true}
                width={3}>
                <Button
                  color={"red"}
                  fluid={true}
                  id="CardBindIdUX-Button-52"
                  onClick={props.onCancel}>
                  {props.languageUX === "en" ? "Cancel" : "ยกเลิก"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardBindIdUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui accordion fluid raised segment"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณาตรวจสอบข้อมูลและกรอก IsHealth ID (IH ID)",
          "valueEN": "Please check your information and enter your IsHealth ID (IH ID)."
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Icon",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-Icon-5"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "HN:",
          "valueEN": "HN:"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-15"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-นามสกุล:",
          "valueEN": "First name & Last Name"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-25"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormGroup-34"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยัน",
          "valueEN": "Confirm"
        },
        "color": {
          "type": "code",
          "value": "\"blue\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-Button-37"
        },
        "onClick": {
          "type": "code",
          "value": "props.onConfirm"
        },
        "size": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.hn"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "props.fullName"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสประจำตัว IH:",
          "valueEN": "IH ID:"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-Input-50"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.ihid"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Button",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "Cancel"
        },
        "color": {
          "type": "code",
          "value": "\"red\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-Button-52"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "inline fields"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.bindHn && {display: \"none\"})}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBindIdUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "อีเมล:",
          "valueEN": "E-mail:"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "code",
          "value": "props.email"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-label-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardBindIdUX-div-58"
        }
      },
      "seq": 8,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "CardBindIdUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 65
}

*********************************************************************************** */
